import Skeleton from '@mui/material/Skeleton';
import { ChartColumnBig, RefreshCw } from 'lucide-react';
import './UserAnalyticsPanel.scss';

const formatDuration = (millis) => {
    if (millis === null || millis === undefined || Number.isNaN(millis)) return '—';
    const hours = millis / (1000 * 60 * 60);
    if (hours < 1) return Math.round(millis / (1000 * 60)) + 'm';
    if (hours < 24) return hours.toFixed(1) + 'h';
    return (hours / 24).toFixed(1) + 'd';
};

export default function UserAnalyticsPanel({ analytics, loading, error, onRetry }) {
    const className = 'userAnalyticsPanel';

    if (loading) {
        return (
            <div className={className}>
                {[0, 1, 2, 3, 4].map((i) => (
                    <div key={i} className={className + '__stat'}>
                        <Skeleton variant="text" width={80} height={34} />
                        <Skeleton variant="text" width={100} height={16} />
                    </div>
                ))}
            </div>
        );
    }

    if (error) {
        return (
            <div className={className + '__state'}>
                <ChartColumnBig className={className + '__state__icon'} />
                <p className={className + '__state__text'}>Couldn't load your performance stats.</p>
                {onRetry && (
                    <button type="button" className={className + '__state__retry'} onClick={onRetry}>
                        <RefreshCw />
                        Try again
                    </button>
                )}
            </div>
        );
    }

    const totalAssigned = analytics?.totalAssigned ?? 0;
    const openCount = analytics?.openCount ?? 0;
    const resolvedCount = analytics?.resolvedCount ?? 0;
    const escalatedCount = analytics?.escalatedCount ?? 0;
    const escalationRate = analytics?.escalationRate ?? 0;
    const reopenedCount = analytics?.reopenedCount ?? 0;
    const reopenRate = analytics?.reopenRate ?? 0;

    return (
        <div className={className}>
            <div className={className + '__stat'}>
                <span className={className + '__stat__value'}>{openCount}</span>
                <span className={className + '__stat__label'}>Open now</span>
            </div>
            <div className={className + '__stat'}>
                <span className={className + '__stat__value'}>{resolvedCount}</span>
                <span className={className + '__stat__label'}>
                    Resolved
                    {totalAssigned > 0 && (
                        <span className={className + '__stat__label__detail'}> ({totalAssigned} lifetime)</span>
                    )}
                </span>
            </div>
            <div className={className + '__stat'}>
                <span className={className + '__stat__value'}>{formatDuration(analytics?.avgClosureMillis)}</span>
                <span className={className + '__stat__label'}>Avg. closure time</span>
            </div>
            <div className={className + '__stat'}>
                <span className={className + '__stat__value'}>{Math.round(escalationRate * 100)}%</span>
                <span className={className + '__stat__label'}>
                    Escalation rate
                    {totalAssigned > 0 && (
                        <span className={className + '__stat__label__detail'}>
                            {' '}
                            ({escalatedCount} of {totalAssigned})
                        </span>
                    )}
                </span>
            </div>
            <div className={className + '__stat'}>
                <span className={className + '__stat__value'}>{Math.round(reopenRate * 100)}%</span>
                <span className={className + '__stat__label'}>
                    Reopen rate
                    {reopenedCount > 0 && (
                        <span className={className + '__stat__label__detail'}> ({reopenedCount} reopened)</span>
                    )}
                </span>
            </div>
        </div>
    );
}
